import { useTranslation } from 'react-i18next';
import { ConnectedProps, connect } from 'react-redux';
import { 
  Column, Field, Input, Row,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { RootState } from 'client/store/configureStore';
import { getUserInfo } from 'client/store/entities/user/user';
import { useEffect } from 'react';
import styles from '../user-settings.module.css';

const UserAccount = ({
  user,
  getUserInfo,
}: PropsFromRedux) => {
  useEffect(() => {
    getUserInfo();
  }, []);

  const { t } = useTranslation();

  const fullName = [user?.firstName, user?.lastName].join(' ');
  return (
    <div className={styles.tabContent}>
      <Row>
        <Column width="400px">
          <Field label={t(translations.name)}>
            <Input value={fullName} disabled />
          </Field>
          <Field label={t(translations.settings_email)}>
            <Input value={user?.email} disabled />
          </Field>
        </Column>
      </Row>
    </div>
  );
};
const mapStateToProps = ({ entities }: RootState) => ({
  user: entities?.user.user,
});

const mapDispatchToProps = {
  getUserInfo,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Container = connector(UserAccount);

export { Container as UserAccount };